// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608281220/js/" + chunkId + "." + {"44":"e87bffb3","225":"b8c7e65b","481":"97450a12","486":"f418bbfa","770":"ba3a2921"}[chunkId] + ".0.7494732729637046.chunk.js";
};